export function getRoutePathFor(...paths: string[]): string {
  return '/' + paths.join('/');
}
